import React from 'react';
import { Card } from '../ui/Card';
import { BarChart3, PieChart, Calendar, FileText, CheckCircle2, Clock, Archive, Sparkles } from 'lucide-react';
import { Forecast, getForecastCoverageStats, ZODIAC_SIGNS } from '../../data/forecastCmsData';
interface AdminForecastAnalyticsProps {
  forecasts: Forecast[];
}
export function AdminForecastAnalytics({
  forecasts
}: AdminForecastAnalyticsProps) {
  const stats = getForecastCoverageStats(forecasts);
  return <div className="space-y-6" data-id="element-4236">
      <div data-id="element-4237">
        <h2 className="text-2xl font-bold text-slate-900" data-id="element-4238">
          Аналитика прогнозов
        </h2>
        <p className="text-slate-500" data-id="element-4239">Статистика покрытия и статусы контента</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-4240">
        <Card padding="lg" className="flex items-center gap-4" data-id="element-4241">
          <div className="w-12 h-12 rounded-full bg-emerald-50 flex items-center justify-center text-emerald-600" data-id="element-4242">
            <CheckCircle2 className="w-6 h-6" data-id="element-4243" />
          </div>
          <div data-id="element-4244">
            <div className="text-2xl font-bold text-slate-900" data-id="element-4245">
              {stats.published}
            </div>
            <div className="text-sm text-slate-500" data-id="element-4246">Опубликовано</div>
          </div>
        </Card>
        <Card padding="lg" className="flex items-center gap-4" data-id="element-4247">
          <div className="w-12 h-12 rounded-full bg-amber-50 flex items-center justify-center text-amber-600" data-id="element-4248">
            <Clock className="w-6 h-6" data-id="element-4249" />
          </div>
          <div data-id="element-4250">
            <div className="text-2xl font-bold text-slate-900" data-id="element-4251">
              {stats.scheduled}
            </div>
            <div className="text-sm text-slate-500" data-id="element-4252">Запланировано</div>
          </div>
        </Card>
        <Card padding="lg" className="flex items-center gap-4" data-id="element-4253">
          <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center text-slate-600" data-id="element-4254">
            <FileText className="w-6 h-6" data-id="element-4255" />
          </div>
          <div data-id="element-4256">
            <div className="text-2xl font-bold text-slate-900" data-id="element-4257">
              {stats.drafts}
            </div>
            <div className="text-sm text-slate-500" data-id="element-4258">Черновики</div>
          </div>
        </Card>
        <Card padding="lg" className="flex items-center gap-4" data-id="element-4259">
          <div className="w-12 h-12 rounded-full bg-purple-50 flex items-center justify-center text-purple-600" data-id="element-4260">
            <Sparkles className="w-6 h-6" data-id="element-4261" />
          </div>
          <div data-id="element-4262">
            <div className="text-2xl font-bold text-slate-900" data-id="element-4263">
              {stats.aiGenerated}
            </div>
            <div className="text-sm text-slate-500" data-id="element-4264">Сгенерировано AI</div>
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-4265">
        <Card padding="lg" data-id="element-4266">
          <h3 className="text-lg font-bold text-slate-900 mb-6 flex items-center gap-2" data-id="element-4267">
            <PieChart className="w-5 h-5 text-indigo-500" data-id="element-4268" /> Покрытие по знакам
            зодиака
          </h3>
          <div className="space-y-4" data-id="element-4269">
            {ZODIAC_SIGNS.map(z => {
            const count = stats.bySign[z.key] || 0;
            const max = Math.max(...Object.values(stats.bySign), 1);
            const percent = Math.round(count / max * 100);
            return <div key={z.key} className="flex items-center gap-4" data-id="element-4270">
                  <div className="w-24 text-sm font-medium text-slate-700 flex items-center gap-2" data-id="element-4271">
                    <span data-id="element-4272">{z.symbol}</span> {z.ru}
                  </div>
                  <div className="flex-1 h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-4273">
                    <div className={`h-full rounded-full ${count === 0 ? 'bg-rose-400' : 'bg-indigo-500'}`} style={{
                  width: `${Math.max(percent, 2)}%`
                }} data-id="element-4274" />
                  </div>
                  <div className="w-8 text-right text-sm font-bold text-slate-900" data-id="element-4275">
                    {count}
                  </div>
                </div>;
          })}
          </div>
        </Card>

        <div className="space-y-6" data-id="element-4276">
          <Card padding="lg" data-id="element-4277">
            <h3 className="text-lg font-bold text-slate-900 mb-6 flex items-center gap-2" data-id="element-4278">
              <BarChart3 className="w-5 h-5 text-indigo-500" data-id="element-4279" /> Типы прогнозов
            </h3>
            <div className="grid grid-cols-3 gap-4" data-id="element-4280">
              <div className="text-center p-4 bg-slate-50 rounded-xl border border-slate-100" data-id="element-4281">
                <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-4282">
                  {stats.daily}
                </div>
                <div className="text-xs text-slate-500 uppercase tracking-wider font-bold" data-id="element-4283">
                  Дневные
                </div>
              </div>
              <div className="text-center p-4 bg-slate-50 rounded-xl border border-slate-100" data-id="element-4284">
                <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-4285">
                  {stats.weekly}
                </div>
                <div className="text-xs text-slate-500 uppercase tracking-wider font-bold" data-id="element-4286">
                  Недельные
                </div>
              </div>
              <div className="text-center p-4 bg-slate-50 rounded-xl border border-slate-100" data-id="element-4287">
                <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-4288">
                  {stats.monthly}
                </div>
                <div className="text-xs text-slate-500 uppercase tracking-wider font-bold" data-id="element-4289">
                  Месячные
                </div>
              </div>
            </div>
          </Card>

          <Card padding="lg" className="bg-gradient-to-br from-indigo-900 to-slate-900 text-white border-none" data-id="element-4290">
            <h3 className="text-lg font-bold mb-2 flex items-center gap-2" data-id="element-4291">
              <Calendar className="w-5 h-5 text-indigo-400" data-id="element-4292" /> Статус системы
            </h3>
            <p className="text-indigo-200 text-sm mb-6" data-id="element-4293">
              Система автоматически публикует запланированные прогнозы каждый
              час.
            </p>
            <div className="space-y-3" data-id="element-4294">
              <div className="flex justify-between items-center text-sm border-b border-white/10 pb-2" data-id="element-4295">
                <span className="text-slate-300" data-id="element-4296">Всего записей в базе</span>
                <span className="font-bold" data-id="element-4297">{stats.total}</span>
              </div>
              <div className="flex justify-between items-center text-sm border-b border-white/10 pb-2" data-id="element-4298">
                <span className="text-slate-300" data-id="element-4299">В архиве</span>
                <span className="font-bold" data-id="element-4300">{stats.archived}</span>
              </div>
              <div className="flex justify-between items-center text-sm pt-1" data-id="element-4301">
                <span className="text-slate-300" data-id="element-4302">
                  Следующая авто-публикация
                </span>
                <span className="font-bold text-emerald-400" data-id="element-4303">Через 14 мин</span>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>;
}